<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<QueryCondition @query="query"  ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
	
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryConditionCount'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
		},
		data() {
			return {
				queryParams: {

				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '统计日期',
						width: 150,
						key: 'countDay',
						align: 'center'
					},
					{
						title: '主渠道编码',
						width: 200,
						key: 'mainChannelCode',
						align: 'center'
					},
					{
						title: '子渠道编码',
						width: 200,
						key: 'childChannelCode',
						align: 'center'
					},
					{
						title: '新增用户数',
						key: 'userNum',
						align: 'center',
						width: 150,
					},
					{
						title: '报名数',
						key: 'applyNum',
						align: 'center',
						width: 150,
					},
					{
						title: '报名用户数',
						key: 'applyUserNum',
						align: 'center',
						width: 150,
					},
					{
						title: '登录用户数',
						key: 'loginUserNum',
						align: 'center',
						width: 150,
					},
					{
						title: 'UV',
						key: 'uv',
						align: 'center',
						width: 150,
					},
					{
						title: '打开次数',
						key: 'openNum',
						align: 'center',
						width: 150,
					},{
						title: '小程序授权用户数',
						key: 'wxPhone',
						align: 'center',
						width: 150,
					}
				]
			},
		},
		created() {
			this.getData();
		},
		methods: {

			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.countChannelPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
		}
	}
</script>